import { render, staticRenderFns } from "./data_tyCab.vue?vue&type=template&id=1e254784&scoped=true"
import script from "./data_tyCab.vue?vue&type=script&lang=js"
export * from "./data_tyCab.vue?vue&type=script&lang=js"
import style0 from "./data_tyCab.vue?vue&type=style&index=0&id=1e254784&prod&lang=scss"
import style1 from "./data_tyCab.vue?vue&type=style&index=1&id=1e254784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e254784",
  null
  
)

export default component.exports